<template>
  <div class="class-rank"  v-loading="!loaded">
    <!-- <div>
      <el-carousel class="carousel-box" height="516px">
        <el-carousel-item v-for="(item, index) in swiper" :key="index">
          <div class="carousel-img" :style="{'background-image': `url(${item})`}"></div>
        </el-carousel-item>
      </el-carousel>
    </div>-->

    <div class="rank">
      <div class="container">
        <div class="listBox">
          <div
            class="listItem"
            :class="[order_by=='sell_num'?'active':'']"
            @click="order_by='sell_num';getclassRank()"
          >课程销量排行</div>
          <div
            class="listItem"
            :class="[order_by=='score'?'active':'']"
            @click="order_by='score';getclassRank()"
          >课程好评排行</div>
        </div>
      </div>
      <ul class="container">
        <li class="clearfix" v-for="(item,index) in ranklist" :key="index">
          <router-link :to="{path:'/classDetail',query:{id:item.id}}">
            <div class="img-box">
              <img :src="item.thumb_image" alt srcset />
            </div>
            <div class="buy">
              <el-button type="danger">立即购买</el-button>
            </div>
            <div class="rank-box" :class="[index>2?'':'active']">{{index+1}}</div>
            <div class="list-right">
              <div class="title">{{item.title}}</div>
              <div>
                <label>专家：</label>
                <span>{{item.expert.real_name}}</span>
              </div>
              <div>
                <label>课程：</label>
                <span>{{item.chapter_number}} 节</span>
              </div>
              <div>
                <span class="sort-price">{{item.price}}</span>
                <span style="display:inline-block;margin-left:20px">
                  <el-rate :value="item.score-0" disabled :colors="['#33b17b','#33b17b','#33b17b']"></el-rate>
                </span>
              </div>
            </div>
          </router-link>
        </li>
      </ul>

      <Empty v-if="loaded&&ranklist.length==0" />
    </div>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
export default {
  name: "OnlineClass",
  components: { Empty },
  data() {
    return {
      swiper: [],
      ranklist: [],
      loaded:false,
      order_by: "sell_num", //score
    };
  },

  created() {
    this.getclassRank();
  },

  methods: {
    getclassRank() {
      this.$http({
        url: "/api/v1/auth/courses",
        method: "get",
        params: { page: 1, limit: 10, order_by: this.order_by },
      }).then((res) => {
        if (res.status == 200) {
          this.loaded=true;
          this.ranklist = res.data.courses;
        } else {
            this.loaded=true;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
// 跑马灯

.carousel-img {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
//   列表
.rank {
  padding-top: 50px;
  padding-bottom: 50px;
}
.rank ul li:hover {
  cursor: pointer;
  box-shadow: 3px 3px 30px #888888;
}
.rank ul li {
  position: relative;
  width: 1119px;
  border: 1px solid #e4ecf3;
  margin: 0 auto;
  border-radius: 16px;
  margin-bottom: 50px;
  padding: 23px 20px 17px 95px;
  box-sizing: border-box;
}
.img-box {
  float: left;
  width: 210px;
  height: 128px;
  margin-right: 26px;
  img {
    width: 210px;
    height: 128px;
  }
}
.list-right {
  float: left;
  line-height: 200%;
  color: rgba(128, 128, 128, 1);
  font-size: 15px;
  .title {
    color: rgba(0, 0, 0, 1);
    font-size: 23px;
  }
  .sort-price {
    margin-top: 14px;
    display: inline-block;
  }
}
.buy {
  position: absolute;
  width: 110px;
  height: 36px;
  line-height: 36px;
  text-align: center;

  border-radius: 5px;
  font-size: 13px;
  right: 105px;
  bottom: 48px;
  button {
    width: 100%;
  }
}
.rank-box {
  position: absolute;
  width: 69px;
  height: 38px;
  line-height: 38px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  font-size: 23px;
  font-weight: bold;
  left: 13px;
  top: 50%;
  margin-top: -19px;
  text-align: center;
  &.active {
    color: #fff;
    background-color: rgba(205, 78, 72, 1);
  }
}
.listBox {
  display: flex;
  padding-bottom: 40px;
  padding-left: 40px;
  .listItem {
    margin-right: 20px;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    padding: 10px 20px;
    &.active {
      color: #cd4e48;
      background-color: rgba(247, 247, 247, 0.8);
      border-radius: 20px;
    }
  }
}
</style>